export default function QuickNav({ links }) {
  return (
    <nav
      className="sticky top-[73px] z-40 -mx-4 px-4 py-2 mb-6 bg-slate-950/90 backdrop-blur border-b border-slate-800/80"
      aria-label="Page sections"
    >
      <ul className="flex gap-2 overflow-x-auto pb-1 scrollbar-thin">
        {links.map((link) => (
          <li key={link.href} className="shrink-0">
            <a
              href={link.href}
              className="block rounded-full border border-slate-700 px-3 py-1.5 text-xs text-slate-400 hover:text-emerald-400 hover:border-emerald-600/50 whitespace-nowrap transition-colors"
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
